<template>
  <form id="arnSchritt2Form">
    <div class="my-4">
        <div class="bgTR px-4 px-lg-5 py-4 py-lg-5">
            <div class="schritt-zaehler-position">
                <SchritteZaehler class="w-100"></SchritteZaehler>
            </div>

            <div class="card border-0 bg-transparent">
                <div class="card-body p-4">
                    <div class="row">
                        <div class="col-md-6">
                          <div class="w-100 d-flex flex-column align-items-start mb-4 mt-4">
                            <div class="d-flex flex-row">
                              <div class="form-label font-xl-links-bold d-block mb-2">
                                Versicherungsnehmer/Antragsteller
                              </div>
                            </div>    
                            <div class="font-base-links">
                              Bitte ergänzen Sie folgende Daten
                            </div>
                          </div>
                        </div> <!-- col-md-6 -->
                        <div class="col-md-6">
                          <div class="w-100 d-flex flex-column align-items-start mb-4 mt-4">
                            <RdnummerOk 
                              v-if="shouldShowRdnummerInfo" 
                              :rdnummer="store.aok" 
                              class="mb-3"
                            />
                          </div>
                        </div>
                    </div> <!-- row -->
                    
                    <div class="row g-3">
                    <!-- Row 1: Anrede + Titel -->
                    <div class="col-md-6">
                        <SelectField
                          id="vnGeschlecht"
                          label="Anrede *"
                          v-model="store.vndaten.anrede"
                          :options="anredeOptions"
                          placeholder="Bitte auswählen"
                          :readonly="isReadonly"
                        />
                    </div>

                    <div class="col-md-6">
                        <SelectField
                          id="vnTitel"
                          label="Akademischer Titel"
                          v-model="store.vndaten.titel"
                          :options="titelOptions"
                          placeholder="Bitte auswählen"
                          :readonly="isReadonly"
                        />
                    </div>

                    <!-- Row 2: Vorname + Nachname -->
                    <div class="col-md-6">
                        <TextField
                          id="vnVorname"
                          label="Vorname *"
                          v-model="store.vndaten.vorname"
                          :readonly="isReadonly"
                        />
                    </div>

                    <div class="col-md-6">
                        <TextField
                          id="vnNachname"
                          label="Nachname *"
                          v-model="store.vndaten.nachname"
                          :readonly="isReadonly"
                        />
                    </div>

                    <!-- Row 3: Geburtsdatum -->
                    <div class="col-md-6">
                        <DateTextPickerField
                          id="vnGeburtstag"
                          label="Geburtsdatum *"
                          v-model="store.vndaten.geburtstag"
                          :readonly="isReadonly"
                        />
                    </div>

                    
                    <div class="col-md-6" v-if="isVigoselect">
                      <TextField
                        id="vnAoknummer"
                        label="AOK Versicherten-Nr. *"
                        v-model="store.vndaten.aoknummer"
                        :readonly="isReadonly"
                      />
                    </div>
                    <div class="col-md-6" v-else><!-- keine AOK-Versichertennummer --></div>

                    <!-- Row 4: Straße + Hausnummer -->
                    <div class="col-md-6">
                        <TextField
                          id="vnStrasse"
                          label="Straße *"
                          v-model="store.vndaten.strasse"
                        />
                    </div>

                    <div class="col-md-6">
                        <TextField
                          id="vnHausnummer"
                          label="Hausnummer *"
                          v-model="store.vndaten.hausnummer"
                        />
                    </div>

                    <!-- Row 5: PLZ + Ort -->
                    <div class="col-md-6">
                        <TextField
                          id="vnPlz"
                          label="PLZ *"
                          v-model="store.vndaten.plz"
                        />
                    </div>

                    <div class="col-md-6">
                        <TextField
                          id="vnOrt"
                          label="Ort *"
                          v-model="store.vndaten.ort"
                        />
                    </div>

                    <!-- Row 6: Land -->
                    <div class="col-md-6">
                        <SelectField
                          id="vnLand"
                          label="Land *"
                          v-model="store.vndaten.land"
                          :options="landOptions"
                        />
                    </div>

                    <div class="col-md-6">
                    </div>

                    <!-- Row 7: E-Mail + Telefon -->
                    <div class="col-md-6">
                        <TextField
                          id="email"
                          label="E-Mail *"
                          type="email"
                          v-model="store.vndaten.email"
                        />
                    </div>

                    <div class="col-md-6">
                        <TextField
                          id="telefon"
                          label="Telefon (nur Ziffern)"
                          v-model="store.vndaten.telefon"
                        />
                    </div>
                    </div>
                </div>
            </div>

            <div class="card border-0 bg-transparent w-100 mt-4">
                <div class="card-body p-4">
                    <div class="w-100 d-flex flex-column align-items-start mb-4 mt-4">
                        <div class="d-flex flex-row">
                            <div class="form-label font-xl-links-bold d-block mb-2">
                                Bankverbindung
                            </div>
                        </div>    
                        <div class="font-base-links">
                            Ich ermächtige die <em>vigo</em> Krankenversicherung VVaG bis auf Widerruf, den Erstbeitrag in Höhe von <b>{{ gesamtErstbeitragStr }}</b> und die Folgebeiträge von unten stehendem Konto abzubuchen.
                        </div>
                    </div>
                    
                    <!-- IBAN + ermittelte Bank -->
                    <div class="row g-3 mb-4">
                      <div class="col-md-6">
                        <TextField
                          id="ktoIban"
                          label="IBAN *"
                          v-model="store.bankdaten.iban"
                        />
                      </div>
                      <div class="col-md-6">
                        <TextField
                          id="ktoBank"
                          label="Bank *"
                          v-model="store.ktobank"
                        />
                      </div>
                    </div>
                    
                    <!-- Kontoinhaber-Auswahl -->
                    <div class="row g-3 mb-4">
                      <div class="col-md-6">
                        <SelectField
                          id="ktoInhaber"
                          label="Ist der Antragsteller auch Kontoinhaber? *"
                          v-model="store.bankabweichend"
                          :options="kontoinhaberOptions"
                          placeholder="Ihre Auswahl"
                        />
                      </div>
                    </div>
                    
                    <!-- Bedingte Felder wenn Kontoinhaber ≠ Antragsteller -->
                    <div v-if="store.bankabweichend === 'ungleich'">
                      <div class="row g-3">
                        <!-- Row 1: Anrede + Titel -->
                        <div class="col-md-6">
                          <SelectField
                            id="ktoGeschlecht"
                            label="Anrede *"
                            v-model="store.bankdaten.anrede"
                            :options="anredeOptions"
                            placeholder="Bitte auswählen"
                          />
                        </div>
                        
                        <div class="col-md-6">
                          <SelectField
                            id="ktoTitel"
                            label="Akademischer Titel"
                            v-model="store.bankdaten.titel"
                            :options="titelOptions"
                            placeholder="Bitte auswählen"
                          />
                        </div>
                        
                        <!-- Row 2: Vorname + Nachname -->
                        <div class="col-md-6">
                          <TextField
                            id="ktoVorname"
                            label="Vorname *"
                            v-model="store.bankdaten.vorname"
                          />
                        </div>
                        
                        <div class="col-md-6">
                          <TextField
                            id="ktoNachname"
                            label="Nachname *"
                            v-model="store.bankdaten.nachname"
                          />
                        </div>
                        
                        <!-- Row 3: Straße + Hausnummer -->
                        <div class="col-md-6">
                          <TextField
                            id="ktoStrasse"
                            label="Straße *"
                            v-model="store.bankdaten.strasse"
                          />
                        </div>
                        
                        <div class="col-md-6">
                          <TextField
                            id="ktoHausnummer"
                            label="Hausnummer *"
                            v-model="store.bankdaten.hausnummer"
                          />
                        </div>
                        
                        <!-- Row 4: PLZ + Ort -->
                        <div class="col-md-6">
                          <TextField
                            id="ktoPlz"
                            label="PLZ *"
                            v-model="store.bankdaten.plz"
                          />
                        </div>
                        
                        <div class="col-md-6">
                          <TextField
                            id="ktoOrt"
                            label="Ort *"
                            v-model="store.bankdaten.ort"
                          />
                        </div>
                        
                        <!-- Row 5: Land -->
                        <div class="col-md-6">
                          <SelectField
                            id="ktoLand"
                            label="Land *"
                            v-model="store.bankdaten.land"
                            :options="landOptionenBankdaten"
                            placeholder="Ihre Auswahl"
                          />
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Navigation Buttons außerhalb bgTR -->
    <div class="d-flex justify-content-end gap-3 mt-4">
      <ZurueckButton @click="handleZurueck" />
      <WeiterButton @click="handleWeiter" />
    </div>
    <p class="text-end text-muted mt-2 font-sm-links">* Pflichtfeld</p>
  </form>
</template>

<script setup>
import { computed, nextTick, onMounted, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { formValidation } from "@form-validation/bundle/popular"
import { Bootstrap5 } from "@form-validation/plugin-bootstrap5"
import { Trigger } from "@form-validation/plugin-trigger"
import { SubmitButton } from "@form-validation/plugin-submit-button"
import { Transformer } from "@form-validation/plugin-transformer"
import { Alias } from "@form-validation/plugin-alias"
import { iban } from '@form-validation/validator-iban'

import { useRechnerStore } from '@/stores/rechner'
import { useMainStore } from '@/stores/useMainStore.js'
import { validatorAnrede, validatorTrimNotEmpty, validatorGebHono, validatorKVNummer, validatorKVNummerSpecial, validatorKVNummerDoppelt } from '@/validators/validatoren'
import { holeBankname, berechneAR20Beitraege, formatiereBeitrag, isValidDateInPast } from '@/helpers/hilfsfunktionen'

import SchritteZaehler from '@/components/general/schritte_zaehler.vue'
import SelectField from '@/fields/SelectField.vue'
import TextField from '@/fields/TextField.vue'
import DateTextPickerField from '@/fields/DateTextPickerField.vue';
import ZurueckButton from '@/components/general/zurueck_button.vue'
import WeiterButton from '@/components/general/weiter_button.vue'
import RdnummerOk from '@/components/general/rdnummer_ok.vue'

const store = useRechnerStore()
const mainStore = useMainStore()
let fv = null

const isVigoselect = computed(() => mainStore.kanal === 'vigoselect');

// ARN-spezifisch: Prüfen ob ARNS (tarif7) oder ARNF (tarif8)
const isARNS = computed(() => {
  const firstItem = store.items[0]
  return firstItem?.tarif7 === 1
})

const isARNF = computed(() => {
  const firstItem = store.items[0]
  return firstItem?.tarif8 === 1
})

// Prüft ob RD-Nummerninfo angezeigt werden soll
const shouldShowRdnummerInfo = computed(() => {
  return mainStore.aokEnabled && store.aok !== 0
})

// ARN-spezifisch: Gesamt-Erstbeitrag berechnen
const gesamtErstbeitrag = computed(() => {
  let summe = 0
  
  // ARNS: Mehrere Personen möglich
  if (isARNS.value) {
    store.items.forEach(item => {
      if (item.tarif7 === 1 && item.tarif7beitrag > 0 && isValidDateInPast(item.geburtstag)) {
        const beitraege = berechneAR20Beitraege(item.tarif7beitrag, store.versicherungsbeginn)
        summe += beitraege.erstbeitrag
      }
    })
  }
  
  // ARNF: Nur eine Person, Beitrag basiert auf ältester Person
  if (isARNF.value) {
    const firstItem = store.items[0]
    if (firstItem?.tarif8 === 1 && firstItem.tarif8beitrag > 0) {
      const beitraege = berechneAR20Beitraege(firstItem.tarif8beitrag, store.versicherungsbeginn)
      summe += beitraege.erstbeitrag
    }
  }
  
  return summe
})

const gesamtErstbeitragStr = computed(() => {
  return formatiereBeitrag(gesamtErstbeitrag.value)
})

// Optionen für Select-Felder
const anredeOptions = [
  { value: 'Herr', text: 'Herr' },
  { value: 'Frau', text: 'Frau' }
]

const titelOptions = [
  { value: '', text: '--' },
  { value: 'Dr.', text: 'Dr.' },
  { value: 'Prof.', text: 'Prof.' },
  { value: 'Prof. Dr.', text: 'Prof. Dr.' }
]

const landOptions = [
  { value: 'DE', text: 'Deutschland' }
]

const kontoinhaberOptions = [
  { value: 'gleich', text: 'Ja' },
  { value: 'ungleich', text: 'Nein' }
]

const landOptionenBankdaten = [
  { value: 'DE', text: 'Deutschland' },
  { value: 'DK', text: 'Dänemark' },
  { value: 'CZ', text: 'Tschechien' },
  { value: 'PL', text: 'Polen' },
  { value: 'AT', text: 'Österreich' },
  { value: 'CH', text: 'Schweiz' },
  { value: 'FR', text: 'Frankreich' },
  { value: 'LU', text: 'Luxemburg' },
  { value: 'BE', text: 'Belgien' },
  { value: 'NL', text: 'Niederlande' }
]

// ARNS: VN-Daten readonly wenn eine VP als VN ausgewählt (wie AR20)
// ARNF: VN-Daten IMMER readonly, da VN = einzige versicherte Person
const isReadonly = computed(() => {
  // ARNF: Immer readonly, da VN automatisch aus VP übernommen wird
  if (isARNF.value) {
    return true
  }
  // ARNS: Readonly wenn VN von einer VP übernommen wurde
  return store.vndaten.id !== 'vn0'
})

// VN initialisieren (wie AR20, ohne vnKrankenkasse)
function initializeVN() {
  // ARNF: VN wird automatisch aus der einzigen VP (items[0]) übernommen
  if (isARNF.value) {
    const vpItem = store.items[0]
    if (vpItem && store.vndaten.id !== vpItem.id) {
      store.setVn(vpItem)
    }

    nextTick(() => {
      if (fv && isVigoselect.value) {
        fv.addField('vnAoknummer', {
          validators: {
            callback: {
              message: 'Bitte geben Sie eine gültige AOK Versicherten-Nr. ein.',
              callback: (input) => {
                if (store.aok !== 0) {
                  return validatorKVNummerSpecial().validate(input).valid;
                }
                return validatorKVNummer().validate(input).valid;
              }
            },
            stringLength: {
              max: 10,
              message: 'Die AOK Versicherten-Nr. darf maximal 10 Zeichen lang sein.'
            },
            checkKVNummerDoppelt: {
              message: 'Die AOK Versicherten-Nr. darf nicht mehrfach verwendet werden.'
            }
          }
        });
      }
    });
    return;
  }

  // ARNS: Wenn keine VN-Auswahl in Schritt1 erfolgte
  if (store.vndaten.id === 'initial') {
    store.setVn(null) // Setzt vn0

    nextTick(() => {
      if (fv) {
        if (isVigoselect.value) {
          fv.addField('vnAoknummer', {
            validators: {
              callback: {
                message: 'Bitte geben Sie eine gültige AOK Versicherten-Nr. ein.',
                callback: (input) => {
                  if (store.aok !== 0) {
                    return validatorKVNummerSpecial().validate(input).valid;
                  }
                  return validatorKVNummer().validate(input).valid;
                }
              },
              stringLength: {
                max: 10,
                message: 'Die AOK Versicherten-Nr. darf maximal 10 Zeichen lang sein.'
              },
              checkKVNummerDoppelt: {
                message: 'Die AOK Versicherten-Nr. darf nicht mehrfach verwendet werden.'
              }
            }
          });
        }
      }
    });
  }
  // Wenn VN bereits gesetzt (VP aus Schritt 1)
  else if (store.vndaten.id !== 'vn0') {
    nextTick(() => {
      if (fv) {
        if (isVigoselect.value) {
          fv.addField('vnAoknummer', {
            validators: {
              callback: {
                message: 'Bitte geben Sie eine gültige AOK Versicherten-Nr. ein.',
                callback: (input) => {
                  if (store.aok !== 0) {
                    return validatorKVNummerSpecial().validate(input).valid;
                  }
                  return validatorKVNummer().validate(input).valid;
                }
              },
              stringLength: {
                max: 10,
                message: 'Die AOK Versicherten-Nr. darf maximal 10 Zeichen lang sein.'
              },
              checkKVNummerDoppelt: {
                message: 'Die AOK Versicherten-Nr. darf nicht mehrfach verwendet werden.'
              }
            }
          });
        }
      }
    });
  }
}

// Watcher für Bankdaten-Abweichung
const { bankabweichend } = storeToRefs(store)

watch(bankabweichend, (newValue) => {
  const myFields = fv?.getFields()
  const exists = myFields ? Reflect.has(myFields, 'ktoGeschlecht') : false

  if (newValue === 'ungleich') {
    nextTick(() => {
      if (!exists) {
        addKontoValidation()
      }
    })
  } 
  
  if (newValue === 'gleich') { 
    nextTick(() => {
      // Bankdaten mit VN-Daten synchronisieren wenn 'gleich' gewählt wird
      store.aktualisiereBankdatenMitVNDaten()
      
      if (exists) {
        removeKontoValidation()
      }
    })
  }
})

// Validierung für Kontoinhaber-Felder hinzufügen
function addKontoValidation() {
  store.bankabweichendValidation = 1
  
  // Bankdaten-Felder IMMER leeren bei Wechsel auf 'ungleich' (außer IBAN und ktobank)
  const oldiban = store.bankdaten.iban
  store.bankdaten = {
    id: 'bankabweichend',
    anrede: '',
    titel: '',
    vorname: '',
    nachname: '',
    strasse: '',
    hausnummer: '',
    plz: '',
    ort: '',
    land: '',
    iban: oldiban
  }
  
  fv.addField('ktoGeschlecht', {
    validators: {
      checkAnrede: {
        message: 'Bitte wählen Sie eine Anrede aus.'
      }
    }
  })
  
  fv.addField('ktoVorname', {
    validators: {
      checkTrimNotEmpty: {
        message: 'Bitte einen Vornamen angeben.'
      },
      stringLength: {
        max: 100,
        message: 'Der Vorname darf maximal 100 Zeichen lang sein.'
      }
    }
  })
  
  fv.addField('ktoNachname', {
    validators: {
      checkTrimNotEmpty: {
        message: 'Bitte einen Nachnamen angeben.'
      },
      stringLength: {
        max: 100,
        message: 'Der Nachname darf maximal 100 Zeichen lang sein.'
      }
    }
  })
  
  fv.addField('ktoStrasse', {
    validators: {
      notEmpty: {
        message: 'Bitte geben Sie eine Straße an.'
      },
      stringLength: {
        max: 100,
        message: 'Die Straße darf maximal 100 Zeichen lang sein.'
      }
    }
  })
  
  fv.addField('ktoHausnummer', {
    validators: {
      notEmpty: {
        message: 'Bitte eine Hausnummer angeben.'
      },
      stringLength: {
        max: 20,
        message: 'Die Hausnummer darf maximal 20 Zeichen lang sein.'
      }
    }
  })
  
  fv.addField('ktoPlz', {
    validators: {
      notEmpty: {
        message: 'Bitte geben Sie eine Postleitzahl an.'
      },
      regexp: {
        regexp: /^[0-9]{5}$/,
        message: 'Bitte geben Sie eine gültige Postleitzahl an.'
      }
    }
  })
  
  fv.addField('ktoOrt', {
    validators: {
      notEmpty: {
        message: 'Bitte geben Sie einen Ort an.'
      },
      stringLength: {
        max: 100,
        message: 'Der Ort darf maximal 100 Zeichen lang sein.'
      }
    }
  })
  
  fv.addField('ktoLand', {
    validators: {
      notEmpty: {
        message: 'Bitte wählen Sie ein Land aus.'
      }
    }
  })
}

// Validierung für Kontoinhaber-Felder entfernen
function removeKontoValidation() {
  store.bankabweichendValidation = 0
  store.aktualisiereBankdatenMitVNDaten()
  
  fv.removeField('ktoGeschlecht')
  fv.removeField('ktoVorname')
  fv.removeField('ktoNachname')
  fv.removeField('ktoHausnummer')
  fv.removeField('ktoStrasse')
  fv.removeField('ktoPlz')
  fv.removeField('ktoOrt')
  fv.removeField('ktoLand')
}

// Navigation: Zurück zu Schritt 1
const handleZurueck = () => {
  store.stepStatus = 1
}

// Navigation: Weiter zu Schritt 3
const handleWeiter = () => {
  if (fv) {
    const button = document.querySelector('[data-shake]')
    fv.validate().then((status) => {
      if (status === 'Valid') {
        // Bankdaten finalisieren: Bei 'gleich' die aktuellen (validierten) VN-Daten übernehmen
        if (store.bankabweichend === 'gleich') {
          store.aktualisiereBankdatenMitVNDaten()
        }

        store.resetVertragsdokumentDownloadStatus()
        store.stepStatus = 3
      } else {
        if (button) {
          button.classList.add('shake')
          setTimeout(() => button.classList.remove('shake'), 500)
        }
        nextTick(() => {
          const firstInvalid = document.querySelector('#arnSchritt2Form .is-invalid')
          if (firstInvalid) {
            firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        })
      }
    })
  }
}

onMounted(async () => {
  // Bankdaten nur aktualisieren wenn bereits 'gleich' gewählt war (z.B. nach Navigation zurück)
  if (store.bankabweichend === 'gleich') {
    store.aktualisiereBankdatenMitVNDaten()
  }
  
  await nextTick()
  
  // FormValidation initialisieren
  const fields = {
    vnGeschlecht: {
      validators: {
        checkAnrede: {
          message: 'Bitte wählen Sie eine Anrede aus.'
        }
      }
    },
    vnGeburtstag: {
      validators: {
        notEmpty: {
          message: 'Bitte ein Geburtsdatum angeben.'
        },
        checkGebHono: {
          message: 'Sie müssen mindestens 18 Jahre alt sein.'
        }
      }
    },
    vnVorname: {
      validators: {
        checkTrimNotEmpty: {
          message: 'Bitte einen Vornamen angeben.'
        },
        stringLength: {
          max: 100,
          message: 'Der Vorname darf maximal 100 Zeichen lang sein.'
        }
      }
    },
    vnNachname: {
      validators: {
        checkTrimNotEmpty: {
          message: 'Bitte einen Nachnamen angeben.'
        },
        stringLength: {
          max: 100,
          message: 'Der Nachname darf maximal 100 Zeichen lang sein.'
        }
      }
    },
    vnStrasse: {
      validators: {
        notEmpty: {
          message: 'Bitte geben Sie eine Straße an.'
        },
        stringLength: {
          max: 100,
          message: 'Die Straße darf maximal 100 Zeichen lang sein.'
        }
      }
    },
    vnHausnummer: {
      validators: {
        notEmpty: {
          message: 'Bitte eine Hausnummer angeben.'
        },
        stringLength: {
          max: 20,
          message: 'Die Hausnummer darf maximal 20 Zeichen lang sein.'
        }
      }
    },
    vnPlz: {
      validators: {
        notEmpty: {
          message: 'Bitte geben Sie eine Postleitzahl an.'
        },
        regexp: {
          regexp: /^[0-9]{5}$/,
          message: 'Bitte geben Sie eine gültige Postleitzahl an.'
        }
      }
    },
    vnOrt: {
      validators: {
        notEmpty: {
          message: 'Bitte geben Sie einen Ort an.'
        },
        stringLength: {
          max: 100,
          message: 'Der Ort darf maximal 100 Zeichen lang sein.'
        }
      }
    },
    vnLand: {
      validators: {
        notEmpty: {
          message: 'Bitte wählen Sie ein Land aus.'
        }
      }
    },
    email: {
      validators: {
        notEmpty: {
          message: 'Bitte geben Sie eine E-Mail Adresse an.'
        },
        stringLength: {
          max: 255,
          message: 'Die E-Mail Adresse darf maximal 255 Zeichen lang sein.'
        },
        emailAddress: {
          message: 'Bitte geben Sie eine gültige E-Mail Adresse an.',
          requireGlobalDomain: true
        }
      }
    },
    telefon: {
      validators: {
        stringLength: {
          max: 50,
          message: 'Die Telefonnummer darf maximal 50 Zeichen lang sein.'
        },
        digits: {
          message: 'Die Telefonnummer darf nur aus Zahlen bestehen.'
        }
      }
    },
    ktoIban: {
      validators: {
        notEmpty: {
          message: 'Bitte geben Sie eine IBAN aus dem SEPA-Raum an.'
        },
        stringLength: {
          max: 50,
          message: 'Die IBAN darf maximal 50 Zeichen lang sein.'
        },
        iban: {
          message: 'Bitte geben Sie eine gültige IBAN aus dem SEPA-Raum an.',
          sepa: true
        }
      }
    },
    ktoBank: {
      validators: {
        notEmpty: {
          message: 'Bitte geben Sie den Namen der Bank an.'
        },
        stringLength: {
          max: 200,
          message: 'Der Bankname darf maximal 200 Zeichen lang sein.'
        }
      }
    },
    ktoInhaber: {
      validators: {
        notEmpty: {
          message: 'Bitte wählen Sie aus, ob der Kontoinhaber vom Antragsteller abweicht.'
        }
      }
    }
  }

  // KANALABHÄNGIG: AOK-Nummer (wird in initializeVN weiter behandelt)
  if (isVigoselect.value) {
    fields.vnAoknummer = {
      validators: {
        callback: {
          message: 'Bitte geben Sie eine gültige AOK Versicherten-Nr. ein.',
          callback: (input) => {
            if (store.aok !== 0) {
              return validatorKVNummerSpecial().validate(input).valid;
            }
            return validatorKVNummer().validate(input).valid;
          }
        },
        stringLength: {
          max: 10,
          message: 'Die AOK Versicherten-Nr. darf maximal 10 Zeichen lang sein.'
        },
        checkKVNummerDoppelt: {
          message: 'Die AOK Versicherten-Nr. darf nicht mehrfach verwendet werden.'
        }
      }
    };
  }
  
  fv = formValidation(document.getElementById('arnSchritt2Form'), {
    fields,
    plugins: {
      bootstrap5: new Bootstrap5(),
      submitButton: new SubmitButton(),
      trigger: new Trigger({ event: 'blur' }),
      transformer: new Transformer({
        'ktoIban': {
          iban: (field, element, validator) => {
            let value = element.value.toUpperCase()
            value = value.replace(/ /g, '').trim()
            element.value = value
            return value
          }
        }
      }),
      alias: new Alias({})
    }
  })
  .registerValidator('checkTrimNotEmpty', validatorTrimNotEmpty)
  .registerValidator('checkGebHono', validatorGebHono)
  .registerValidator('checkAnrede', validatorAnrede)
  .registerValidator('checkKVNummerDoppelt', validatorKVNummerDoppelt)
  .registerValidator('iban', iban)
  .on('core.validator.validated', function (e) {
    if (e.field === "ktoIban" && e.validator === "iban") {
      if (e.result.valid === true && store.bankdaten.iban && store.bankdaten.iban.length > 0) {
        holeBankname(store.bankdaten.iban).then(bankName => {
          store.ktobank = bankName
          nextTick(() => {
            if (fv) {
              fv.revalidateField('ktoBank')
            }
          })
        }).catch(error => {
          store.ktobank = ""
          nextTick(() => {
            if (fv) {
              fv.revalidateField('ktoBank')
            }
          })
        })
      } else {
        store.ktobank = ""
        nextTick(() => {
          if (fv) {
            fv.revalidateField('ktoBank')
          }
        })
      }
    }
  })
  
  // VN initialisieren
  initializeVN()
  
  // Wenn IBAN bereits vorhanden aber kein Bankname, dann abrufen
  if (store.bankdaten.iban && store.bankdaten.iban.length > 0 && !store.ktobank) {
    holeBankname(store.bankdaten.iban).then(bankName => {
      store.ktobank = bankName
    }).catch(error => {
      store.ktobank = ""
    })
  }
})
</script>

<style scoped>
.schritt-zaehler-position {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
}

@media (min-width: 768px) {
  .schritt-zaehler-position {
    width: 80vw;
  }
}

@media (min-width: 992px) {
  .schritt-zaehler-position {
    width: 70vw;
  }
}

@media (min-width: 1200px) {
  .schritt-zaehler-position {
    width: 60vw;
  }
}

/* Shake Animation für ungültige Formulare */
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
  20%, 40%, 60%, 80% { transform: translateX(5px); }
}

.shake {
  animation: shake 0.5s ease-in-out;
}
</style>
